import React, { useState, useEffect } from 'react';
import styles from './TeamSection.module.css';

const POSITION_LABELS = { G: 'Guard', F: 'Forward', C: 'Center' };

const TeamSection = () => {
  const [players, setPlayers] = useState([]);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        const res = await fetch('/content/players.json');
        const data = await res.json();
        setPlayers(data);
      } catch {
        setPlayers([]);
      }
    };
    fetchPlayers();
  }, []);

  const filtered =
    filter === 'all'
      ? players
      : players.filter((p) => p.status === filter);

  return (
    <section id="players" className="section section--alt">
      <div className="section__inner">
        <h2 className="section__title">The Roster</h2>

        <div className={styles.filters}>
          {['all', 'active', 'injured', 'retired'].map((f) => (
            <button
              key={f}
              className={`${styles.filterBtn} ${filter === f ? styles.filterActive : ''}`}
              onClick={() => setFilter(f)}
            >
              {f === 'all' ? 'All' : f.charAt(0).toUpperCase() + f.slice(1)}
            </button>
          ))}
        </div>

        <div className={styles.grid}>
          {filtered.map((player) => (
            <div key={player.id} className={styles.card}>
              <div className={styles.imageWrap}>
                {player.image ? (
                  <img
                    src={player.image}
                    alt={`${player.firstName} ${player.lastName}`}
                    className={styles.image}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                ) : null}
                <div className={styles.fallbackAvatar} style={{ display: player.image ? 'none' : 'flex' }}>
                  <span className={styles.fallbackNumber}>#{player.number}</span>
                </div>
                <span className={styles.number}>#{player.number}</span>
              </div>
              <div className={styles.info}>
                <h3 className={styles.name}>
                  {player.firstName} {player.lastName}
                  {player.captain && <span className={styles.captain}>C</span>}
                </h3>
                <div className={styles.meta}>
                  <span className={styles.position}>
                    {POSITION_LABELS[player.position] || player.position}
                  </span>
                  <span className={`badge badge--${player.status}`}>
                    {player.status}
                  </span>
                </div>
                {player.quote && (
                  <p className={styles.quote}>"{player.quote}"</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
